import "./drawerStats.css";

/** Numbered steps in the same rail as key dates. */
export default function StepFlow({ steps, label = "Steps in order" }) {
  const items = (steps || []).map((step) => String(step || "").trim()).filter(Boolean);
  if (!items.length) return null;

  return (
    <ol className="ds-flow" aria-label={label}>
      {items.map((step, index) => (
        <li className="ds-flow-step" key={`${index}-${step}`}>
          <span className="ds-flow-node" aria-hidden="true">
            {index + 1}
          </span>
          <div className="ds-flow-card">
            <div className="ds-flow-value">{step}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
